import { render, staticRenderFns } from "./mod2.vue?vue&type=template&id=2d08c63c&scoped=true&"
import script from "./mod2.vue?vue&type=script&lang=js&"
export * from "./mod2.vue?vue&type=script&lang=js&"
import style0 from "./mod2.vue?vue&type=style&index=0&id=2d08c63c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d08c63c",
  null
  
)

export default component.exports